const config = {
  azureOpenAI: {
    whisperKey: process.env.REACT_APP_AZURE_OPENAI_WHISPER_KEY || "",
    whisperUrl: process.env.REACT_APP_AZURE_OPENAI_WHISPER_URL || "",
    chatEndpoint: process.env.REACT_APP_AZURE_OPENAI_CHAT_ENDPOINT || "",
    chatKey: process.env.REACT_APP_AZURE_OPENAI_CHAT_KEY || "",
    chatDeployment: process.env.REACT_APP_AZURE_OPENAI_CHAT_DEPLOYMENT || "gpt-4o",
  },
};

export default config;
